const ITEMS = [
  "FULL TRUCKLOAD",
  "LTL CONSOLIDATION",
  "EXPEDITED",
  "REFRIGERATED",
  "FLATBED & SPECIALIZED",
  "DRAYAGE",
  "HAZMAT CERTIFIED",
  "INTERMODAL",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="services-marquee"
      className="relative overflow-hidden border-y border-[#222736] bg-[#0C0E13] py-6"
    >
      <div className="marquee-track flex w-max items-center">
        {row.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="whitespace-nowrap px-8 font-display text-2xl font-black uppercase tracking-tight text-[#2A3042] sm:text-3xl">
              {item}
            </span>
            <span className="h-2 w-2 rotate-45 bg-[#F59E0B] shadow-[0_0_12px_rgba(245,158,11,0.7)]" />
          </div>
        ))}
      </div>
    </div>
  );
}
